<template>
    <div class="checkoutSummary">
        <div class="checkoutSummaryPosition" :class="{
            'absolute': position === 'absolute'
        }">
            <div class="checkoutSummary-header">
                <img src="/img/adt-logo.svg"
                     class="logoAdt"
                     alt="ADT Shield">
                <div class="text">
                    Have any questions?
                    <br> Need to talk to a security expert?
                </div>
            </div>
            <div class="checkoutSummary-assistance">
                If you need assistance, please contact our beloved support staff. They love to help!
            </div>
            <div class="checkoutSummary-phone">
                {{ supportNumber }}
            </div>
            <div class="checkoutSummaryCard">
                <div class="title">Summary</div>
                <div class="features">
                    <div class="feature">Custom {{ lead.protectionLevel }} System</div>
                    <div class="feature">Standard ADT Monitoring agreement</div>
                </div>
                <hr>
                <div class="lineItems">
                    <div class="lineItem">
                        <div class="description">Equipment</div>
                        <div class="price">{{ system.totalFormatted }}</div>
                    </div>
                    <div class="lineItem"
                         v-for="(discount, index) in system.discounts" :key="index">
                        <div class="description">{{ discount.title }}</div>
                        <div class="price">- {{ discount.value }}</div>
                    </div>
                </div>
                <hr>
                <div class="checkoutSummaryCard-footer">
                    <div class="totalText">
                        Total one time cost
                    </div>
                    <div class="price">{{ system.discountedTotalFormatted }}</div>
                </div>
            </div>
        </div>
    </div>
</template>



<script>
import { mapActions, mapState } from 'vuex'
export default {
    props: {
        position: {
            default: 'relative'
        }
    },
    computed: {
        ...mapState(['system', 'supportNumber', 'lead'])
    },
    methods: {
        ...mapActions([])
    }
}
</script>

<style lang="css"></style>
